var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAdd = function SvgIconAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_13464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20C9.52667 20 9.14278 19.6167 9.14278 19.1428V0.857222C9.14278 0.629873 9.23309 0.411835 9.39385 0.251075C9.55461 0.0903142 9.77265 0 10 0C10.2273 0 10.4454 0.0903142 10.6061 0.251075C10.7669 0.411835 10.8572 0.629873 10.8572 0.857222V19.1428C10.8572 19.6161 10.4739 20 10 20ZM19.1428 10.8572H0.857222C0.629873 10.8572 0.411835 10.7669 0.251075 10.6061C0.0903142 10.4454 0 10.2273 0 10C0 9.77265 0.0903142 9.55461 0.251075 9.39385C0.411835 9.23309 0.629873 9.14278 0.857222 9.14278H19.1428C19.3701 9.14278 19.5882 9.23309 19.7489 9.39385C19.9097 9.55461 20 9.77265 20 10C20 10.2273 19.9097 10.4454 19.7489 10.6061C19.5882 10.7669 19.3701 10.8572 19.1428 10.8572Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_13464"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
export default SvgIconAdd;